import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { useContactAdvisor } from 'shared/hooks';
import Button from '@mui/material/Button';
import Box from '@mui/material/Box';
import EmailIcon from '@mui/icons-material/Email';
import Typography from '@mui/material/Typography';
import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles(theme => ({
  buttonIcon: {
    marginRight: theme.spacing(1),
  },
}));

const Contact = ({ toggleMessageModal, children }) => {
  const classes = useStyles();
  const { t } = useTranslation();

  return (
    <>
      {children}
      <Box mt={2}>
        <Button onClick={toggleMessageModal} variant="contained" size="small" color="primary">
          <EmailIcon className={classes.buttonIcon} />
          {t('Message')}
        </Button>
      </Box>
    </>
  );
};

Contact.propTypes = {
  toggleMessageModal: PropTypes.func.isRequired,
  children: PropTypes.node.isRequired,
};

const ContactAdvisorDone = () => {
  const { t } = useTranslation();

  return (
    <>
      <Typography display="block">{t('Your score request has been initiated.')}</Typography>
      <Typography display="block">
        {t('You will be notified further on its availability.')}
      </Typography>
    </>
  );
};

const ContactAdvisor = ({ children }) => {
  const [messageSent, toggleMessageModal, RenderModal] = useContactAdvisor();

  return !messageSent ? (
    <>
      <Contact toggleMessageModal={toggleMessageModal}>{children}</Contact>
      <RenderModal />
    </>
  ) : (
    <ContactAdvisorDone />
  );
};

ContactAdvisor.defaultProps = {
  children: undefined,
};

ContactAdvisor.propTypes = {
  children: PropTypes.node,
};

export default ContactAdvisor;
